import { Trans } from 'react-i18next'

import {
  STATIC_ANIMATION_DURATION,
  start,
} from '~/pages/onboarding/preparePlan/libs/components/PreparePlan/constants'
import { PreparePlanStyles as S } from '~/pages/onboarding/preparePlan/libs/components/PreparePlan/styles'
import ProgressAnalyzer from '~/shared/components/ProgressAnalyzer'
import { SvgImage } from '~/shared/components/SvgImage'
import { COLORS } from '~/shared/constants/uiConstants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { useProgressAnimationData } from '~/shared/hooks/useProgressAnimationData'

interface Props {
  nextPagePath: string
  pageId: string
}

const PreparePlan = ({ nextPagePath, pageId }: Props) => {
  const { handleChange } = useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: '',
  })
  const goToNextPage = () => handleChange('', handleContinue)

  const { firstCounter, secondCounter, thirdCounter, fourthCounter } =
    useProgressAnimationData({
      goToNextPage,
      STATIC_ANIMATION_DURATION,
    })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.Title>
          <Trans i18nKey="onboarding.preparePlan.title" />
        </S.Title>

        <S.ProgressContainer>
          <ProgressAnalyzer color={COLORS.PURPLE_400} value={firstCounter}>
            <Trans i18nKey="onboarding.preparePlan.goalsAligning" />
          </ProgressAnalyzer>

          <ProgressAnalyzer color={COLORS.PURPLE_400} value={secondCounter}>
            <Trans i18nKey="onboarding.preparePlan.skillsToImprove" />
          </ProgressAnalyzer>

          <ProgressAnalyzer color={COLORS.PURPLE_400} value={thirdCounter}>
            <Trans i18nKey="onboarding.preparePlan.contentPicking" />
          </ProgressAnalyzer>

          <ProgressAnalyzer color={COLORS.PURPLE_400} value={fourthCounter}>
            <Trans i18nKey="onboarding.preparePlan.challengesPrioritizing" />
          </ProgressAnalyzer>
        </S.ProgressContainer>

        <S.EnjoyTitle>
          <Trans i18nKey="onboarding.preparePlan.enjoyedTitle" />
        </S.EnjoyTitle>

        <S.Review>
          <S.ReviewStars>
            {Array.from({ length: 5 }).map((_, i) => (
              <SvgImage svg={start} key={i} width={16} />
            ))}
          </S.ReviewStars>

          <S.ReviewText>
            <Trans i18nKey="onboarding.preparePlan.review.first.title" />
          </S.ReviewText>

          <S.ReviewAuthor>
            <Trans i18nKey="onboarding.preparePlan.review.first.author" />
          </S.ReviewAuthor>
        </S.Review>
      </S.StyledContainer>
    </S.Root>
  )
}

export default PreparePlan
